import { CREDIT_ROUTES } from '@credit-web/shared/infra'
import { CARDS_ROUTES } from 'cards/shared/cards-ports'
import { DELAY_PAYMENTS_ROUTES } from 'delay-payments/shared/misc'
import { INSURANCE_ROUTES } from 'insurance/shared/insurance-ports'
import { INVESTMENTS_ROUTES } from 'investments/shared/misc'
import { SWH_ROUTES } from 'swh/shared/utils'

import { ACQUIRER_ROUTES } from '~/domains/acquirer/ports/acquirer.routes'
import { BANKING_ROUTES } from '~/domains/banking/ports/banking.routes'
import { MISCELLANEOUS_ROUTES } from '~/domains/miscellaneous/ports/miscellaneous.routes'
import { RISK_ROUTES } from '~/domains/risk/ports/risk.routes'
import { STONE_ACCOUNT_ROUTES } from '~/domains/stone-account/ports/stone-account.routes'
import { SVA_ROUTES } from '~/domains/sva/ports/sva.routes'

import { blackBirdFactory } from './blackbird'

const GENERIC_ROUTES = ['/', '/home', '/home-indisponivel', '/404'] as const
const PUBLIC_ROUTES = ['/termos-uso-cartao-credito', '/autocred', '/conta-pj'] as const

export const routes = [
  ...GENERIC_ROUTES,
  ...BANKING_ROUTES,
  ...STONE_ACCOUNT_ROUTES,
  ...RISK_ROUTES,
  ...ACQUIRER_ROUTES,
  ...MISCELLANEOUS_ROUTES,
  ...SVA_ROUTES,
  ...CREDIT_ROUTES,
  ...INVESTMENTS_ROUTES,
  ...DELAY_PAYMENTS_ROUTES,
  ...PUBLIC_ROUTES,
  ...SWH_ROUTES,
  ...INSURANCE_ROUTES,
  ...CARDS_ROUTES
]

export type Routes = (typeof routes)[number]
/**
 * @deprecated use the 'shared/blackbird' api type
 */
const BlackBird = blackBirdFactory<Routes>(routes)

export { blackBirdFactory }

export default BlackBird
